import {Component, Input} from '@angular/core';
import {SelectionListOption} from '../selection-list.component';

@Component({
    selector: 'ui-kit-selection-item-group',
    template: '',
    standalone: false
})
export class SelectionItemGroupComponent implements SelectionListOption<any[]> {
    @Input() label: string;
    @Input() value: any[];
    @Input() disabled = false;
}
